module.exports = __webpack_public_path__ + "static/media/icn_merch.1c9cdb8b.svg";